module.exports = __webpack_public_path__ + "img/20190816132348938.82ee4dd7.png";